import React from "react";
import * as style from "./style.module.scss";

type Props = {
    children: React.ReactNode;
};

const HorizontalLayout = ({ children }: Props) => {
    return <div className={style.container}>{children}</div>;
};

export default HorizontalLayout;
